import axios from "axios";
const backEndUrl = process.env.REACT_APP_API_ENDPOINT;
const makeBackendUrl = process.env.REACT_APP_MAKEAPI_ENDPOINT;
let cancelTokenSource = null;

export const fetchQuotationsForSupplier = (supplierId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-rfqs-for-supplier/${supplierId}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getRFQById = (rfqOfferId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(`${backEndUrl}/get-rfqs-by-id/${rfqOfferId}`, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getOrginizationDetails = async () => {
  try {
    const response = await axios.get(`${makeBackendUrl}/api/v2/common/masters/organization`);
    return response.data;

  } catch (error) {
    return false;
  }
}

export const getRFQByRFQRefId = (rfqOfferId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-rfqs-by-rfq-ref-id/${rfqOfferId}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};
export const getRFQByRFQId = (rfqOfferId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-rfqs-by-rfq-id/${rfqOfferId}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const handleDeclineRFQ = (data, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(`${backEndUrl}/decline-rfq`, data, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const createOfferAcceptedPO = async (data, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("token", token);
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      let response = await axios.post(
        `${backEndUrl}/create-purchase-order-offer`,
        data,
        {
          headers: header,
        }
      );

      return resolve(response.data);
    } catch (err) {
      console.log("err", err);
      return reject(err);
    }
  });
};

export const declineOffer = async (data, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(`${backEndUrl}/decline-purchase-offer-order`, { data: data }, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
}


export const ReturnSubmitQuotations = async (data, supplierid, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(`${backEndUrl}/return-submit-quotations-offer`, { data: data, supplierid: supplierid }, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
}

export const submitRFQ = (data, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.post(`${backEndUrl}/submit-rfq`, data, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getSignedUrlForFile = async (fileName, responseType = 'blob') => {
  let token = localStorage.getItem("Token");
  try {
    let header = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      "Content-Type": "application/json",
    };
    let response = await axios
      .get(
        `${process.env.REACT_APP_MAKEAPI_ENDPOINT}/comman/get-signed-url-for-file-name/${fileName}?responseType=${responseType}`,
        { headers: header, responseType }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchOrderForSupplier = (supplierId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-orders-for-supplier/${supplierId}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getOrderByPoRefId = (id, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-order-by-po-ref-id/${id}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};
export const getOrderByPoId = (id, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/get-order-by-id/${id}`,
        {
          headers: header,
        }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const handleAcceptPO = (token, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.put(
        `${backEndUrl}/common/accept-po`,
        payload,
        { headers: header }
      );
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateShippingInformation = (token, formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/update-shipping-info`,
        formData,
        { headers: header }
      );
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateDeliveryInformation = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/update-delivery-info`,
        data,
        { headers: header }
      );
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getSalesOrderById = (token, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${process.env.REACT_APP_MAKEAPI_ENDPOINT}/comman/fetch-order-for-po/${data}`,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateQualityDocsFromSupplier = (token, formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/upload-quality-document-by-supplier`,
        formData,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateConsignMentPhotoFromSupplier = (token, formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/upload-consignment-photo-by-supplier`,
        formData,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getIssuesForPO = async (token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(`${backEndUrl}/common/get-all-po-issue`, {
        headers: header,
      });
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};


export const uploadRFQDocument = (token, formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/upload-rfq-document`,
        formData,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const deleteRFQDocument = (token, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.delete(
        `${backEndUrl}/delete-rfq-document/${payload}`,
        { headers: header }
      );
      return resolve(response);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateExpectedShippingDates = (token, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.put(`${backEndUrl}/update-esd`, payload, {
        headers: header,
      });
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const getEightXAddress = async (token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${process.env.REACT_APP_MAKEAPI_ENDPOINT}/admin/get-eightx-address`,
        { headers: header }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const downloadPurchaseOrderPdf = async (payload, token) => {
  try {
    let header = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      "Content-Type": "application/json",
    };

    let response = await axios.post(
      `${backEndUrl}/common/download-po-pdf`,
      payload,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

export const getBillsByPoId = async (token, purchaseOrderId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };
      let response = await axios.get(
        `${backEndUrl}/common/bills/purchase-order/${purchaseOrderId}`,
        { headers: header }
      );
      return resolve(response.data);
    } catch (error) {
      return reject(error);
    }
  });
};

export const createBillForPurchaseOrder = (token, formData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
      };

      let response = await axios.post(
        `${backEndUrl}/create-bill-for-po`,
        formData,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const updateBillShipData = (token, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      let response = await axios.put(
        `${backEndUrl}/common/bill/ship-data`,
        payload,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};


export const getRFQForSupplier = async (token, supplierId, refId, selectedProcess, requestedDate, projectName, status, page, itemsPerPage = 2) => {
  status = status || 'Pending for Quotation';
  cancelTokenSource && cancelTokenSource();
  try {

    let headers = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      "Content-Type": "application/json",
    };
    const response = await axios.post(`${backEndUrl}/get-req-for-supplier`, {
      supplierId,
      refId,
      selectedProcess,
      requestedDate,
      projectName,
      status,
      page,
      itemsPerPage,
    }, {
      headers,
      cancelToken: new axios.CancelToken((c) => cancelTokenSource = c),
    });
    return response.data;


  } catch (error) {
    console.log(error);
    return false;
  }


}

export const getOrderForSupplier = async (category, token, supplierId, refId, selectedProcess, requestedDate, poNumber, projectName, status, page, itemsPerPage = 10) => {
  cancelTokenSource && cancelTokenSource();
  try {
    let headers = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      "Content-Type": "application/json",
    };
    const response = await axios.post(`${backEndUrl}/get-order-for-supplier`, {
      supplierId,
      refId,
      selectedProcess,
      requestedDate,
      poNumber,
      projectName,
      status,
      category,
      page,
      itemsPerPage,

    }, {
      headers,
      cancelToken: new axios.CancelToken((c) => cancelTokenSource = c),
    });
    return response.data;

  } catch (error) {
    if (error.response && error.response.status === 401) {
      //remove token and redirect
      localStorage.clear();
      window.location.href = '/login';
    } else {
      console.error("Error fetching order data:", error);
    }
    return null;
  }
};
export const downloadBatchFile = async (id, type) => {
  try {

    let response = await axios.post(`${backEndUrl}/common/download-batch-rfq-offer`, { id, type }, { responseType: "blob" });
    return response.data;

  } catch (err) {
    return reject(err);
  }
}

